import { FC, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import { IEmployee } from 'routes/client/structure/employees/types';
import { useActiveClientContext } from 'store/active-client';
import { buildClientEntity, buildClientUrl } from 'utils/helpers/client';
import { useTranslation } from 'react-i18next';
import FetchTable from 'components/table/FetchTable';
import { Column } from 'react-table';
import { buildFilters } from 'components/table/utils/filtersConfig';

interface IProps {
  groupId: string;
}

const Employees: FC<IProps> = ({ groupId }) => {
  const { t } = useTranslation();
  const { client } = useActiveClientContext();
  const history = useHistory();

  const statusOptions = [
    { value: 'active', label: t('table.activeStatus') },
    { value: 'inactive', label: t('table.inactiveStatus') },
    { value: 'released', label: t('table.releasedStatus') },
  ];

  const columns: Array<Column<IEmployee>> = [
    {
      Header: 'ID',
      accessor: 'id',
    },
    {
      Header: t('structure.groups.name') || '',
      accessor: 'name',
      Cell: ({ value, row }) => {
        const { id, can_edit: canEdit } = row.original;
        if (canEdit)
          return (
            <span
              className="ml-1 u-underline u-color-inherit u-cursor-pointer"
              onClick={() => history.push(buildClientUrl(`/structure/employees/edit/${id}`, client))}
            >
              {value}
            </span>
          );

        return value;
      },
    },
    {
      Header: t('structure.employees.position') || '',
      accessor: 'position',
      disableSortBy: true,
    },
  ];

  const tableFilters = useMemo(() => {
    return [
      buildFilters({
        name: 'status',
        placeholder: t('structure.employees.status'),
        options: statusOptions,
        isMulti: true,
        showTotal: true,
        allowSelectAll: true,
      }),
    ];
  }, [t]);

  return (
    <div className="position-relative mt-5">
      <h3
        className="h5 position-absolute"
        style={{ top: '1rem', left: 0 }}
      >
        {t('structure.roles.employees')}
      </h3>
      <FetchTable<IEmployee>
        entityName={buildClientEntity('roles-employees', client)}
        entityEndpoint={`users/roles/${groupId}`}
        columns={columns}
        pageLimit={10}
        pagination
        filters={tableFilters}
        hideSearch
        useBackendSorting
      />
    </div>
  );
};

export default Employees;
